// extracted by mini-css-extract-plugin
export default {"title":"WoJW9E","emptyState":"jtVD5r"};